import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const HorizonSelector = styled.div`
  display: flex;
  padding: 8px 4px;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--border-soft);
`;

export const HorizonItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 20%;
  text-align: center;
`;

export const HorizonItemTitle = styled.div`
  ${typographyV2.uiXs};
  color: var(--text-default);
`;

export const HorizonItemValue = styled.span<{ $isNegative: boolean }>`
  ${typographyV2.uiSm};
  font-family: var(--font-roboto-mono);
  color: ${props =>
    props.$isNegative ? 'var(--viz-bearish)' : 'var(--viz-bullish)'};
`;
